import callAPI from "../callApi";
import path from "../variables";

const Currency = {
	convert: (filter?: string) =>
		callAPI("GET", `${path.base}/currency/convert${filter || ""}`, "", "converting currency"),
	list: () =>
		callAPI("GET", `${path.base}/currency/list`, "", "getting currency list"),
	rate: (filter?: string) =>
		callAPI("GET", `${path.base}/currency/rate${filter || ""}`, "", "getting exchange rate"),
};

export default Currency;
